import React, { useEffect, useRef, useState } from 'react'
import cogoToast from 'cogo-toast-react-17-fix';
import { Icon } from 'react-icons-kit';
import { androidOpen } from 'react-icons-kit/ionicons/androidOpen'
import { basic_mail } from 'react-icons-kit/linea/basic_mail'


import API from '.././../../../ApiConfig'
import { GET_ALL_DOCS_ISSUER_ID, GET_DEFAULT_FIELDS, GET_DISTINCT_ISSUER, VERIFIER_SEARCH, HOLDER_CONSENT, BASE_URL, USER_TOKEN } from '../../../../Utils/constant'
import { BUTTONS, MESSAGE } from '../../../../Utils/Strings';
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper';

import TopTitleBar from '../TopTitleBar'
import ShimmerLoader from '../../../../components/ShimmerLoader';
import styles from './VerifyUsers.module.css'
import TableStyles from "../../AllUsers.module.css"
import { EMAIL_CHECK, NAME_CHECK, _ToNormal, convertDateFormat } from '../../../../Utils/helper';
import Modal from '../../../../Utils/Modal';
import useRefreshToken from '../../../../Hooks/usegenerateToken';
import { useSelector } from 'react-redux';


export default function VerifyUsers({ id }) {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const userData = useSelector(state => state.User)
    const [loading, setLoading] = useState(false)
    const [Issuers, setIssuers] = useState([])
    const [Documents, setDocuments] = useState([])
    const [DefaultFields, setDefaultFields] = useState([])
    const [formData, setFormData] = useState()
    const [loadShimmer, setLoadshimmer] = useState(0)

    const [Popup, setPopup] = useState(false);

    const [result, setresult] = useState([])

    const [company, setCompany] = useState([]);
    const [doc, setDoc] = useState();

    useEffect(() => {
        getAllIssuers()
    }, [])

    useEffect(() => {
        if (company?.id)
            getAllDocsByIssuer()
    }, [company])

    useEffect(() => {
        if (doc?.id)
            getAllDefaultDocId()
    }, [doc])

    async function getAllIssuers() {
        setLoading(true)
        API.get(GET_DISTINCT_ISSUER) //change to distinct issuer
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    setIssuers(res.data.data)
                }
            })
            .catch(err => {
                setLoading(false)
                cogoToast.error(err.message)
            })
    }

    async function getAllDocsByIssuer() {
        setLoadshimmer(1)
        API.get(GET_ALL_DOCS_ISSUER_ID + company.id) //change to distinct documents
            .then(res => {
                if (res.data.status === 200) {
                    setDocuments(res.data.data)
                }
            })
            .catch(err => {
                cogoToast.error(err.message)
            })
            .finally(() => setLoadshimmer(0))
    }

    async function getAllDefaultDocId() {
        setLoadshimmer(2)
        setresult([])
        setFormData(null)
        API.get(GET_DEFAULT_FIELDS + doc.id) //change to distinct documents
            .then(res => {
                if (res.data.status === 200) {
                    setDefaultFields(res.data.data)
                }
            })
            .catch(err => {
                cogoToast.error(err.message)
            })
            .finally(() => setLoadshimmer(0))
    }

    async function getSearchResults(api_data) {
        setLoadshimmer(3)
        let ls = []
        API.post(VERIFIER_SEARCH, api_data)
            .then(res => {
                if (res.data.status === 200) {
                    ls.push(res.data.data)
                    setresult(ls)
                }
            })
            .catch(err => {
                cogoToast.error(err.response.data.message)
            })
            .finally(() =>
                setLoadshimmer(false)
            )
    }

    const Dropdown = ({ listType, list, selectedOption }) => {
        const [isOpen, setIsOpen] = useState(false);
        const dialogBox = useRef(null);
        const handleToggle = () => {
            setIsOpen(!isOpen);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dialogBox.current && !dialogBox.current.contains(event.target)) {
                    setIsOpen(false);
                }
            };
            document.addEventListener('click', handleClickOutside);
            return () => {
                document.removeEventListener('click', handleClickOutside);
            };
        }, []);
        if (listType == 0) {
            return (
                <>
                    <div className={styles.letter} ref={dialogBox}>
                        <div className={styles.lettertype} onClick={handleToggle} style={{ cursor: "pointer" }}>
                            <div className={styles.selectItem}>

                                <p> {selectedOption?.company_name ? selectedOption.company_name : 'Choose Issuer'}</p>
                                {isOpen ? <img src='/chevrondown.svg' style={{ transform: "rotate(180deg)" }} /> : <img src='/chevrondown.svg' />}
                            </div>
                        </div>
                        <div className={styles.customDropdown} style={{ width: "48%" }}>
                            {isOpen && (
                                <div className={styles.dropdownOptions}>
                                    {list.map((i) => (
                                        <div key={i.id} className={styles.dropdownList} onClick={() => setCompany(i)}>
                                            {i.company_name}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </>
            );
        }

        else {
            return (
                <>
                    <div className={styles.letter} ref={dialogBox}>
                        <div className={styles.lettertype} onClick={handleToggle} style={{ cursor: "pointer" }}>
                            <div className={styles.selectItem}>

                                <p> {selectedOption?.doc_name ? _ToNormal(selectedOption.doc_name) : 'Choose Document'}</p>
                                {isOpen ? <img src='/chevrondown.svg' style={{ transform: "rotate(180deg)" }} /> : <img src='/chevrondown.svg' />}
                            </div>
                        </div>
                        <div className={styles.customDropdown} style={{ width: "48%" }}>
                            {isOpen && (
                                <div className={styles.dropdownOptions}>
                                    {list.map((i) => (
                                        <div key={i.id} className={styles.dropdownList} onClick={() => setDoc(i)}>
                                            {_ToNormal(i.doc_name)}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </>
            );
        }
    };

    const DynamicForm = ({ fields }) => {
        const reset = () => {
            setCompany(null);
            setDocuments([]);
            setDoc(null);
            setFormData(null);
            setDefaultFields([]);
            setFormValues(initialFormValues);
            setErrors({});
        };

        let initialFormValues = fields.reduce((acc, field) => {
            acc[field.field_name] = field.default_value || '';
            return acc;
        }, {});

        if (formData) {
            initialFormValues = formData;
        }

        const [formValues, setFormValues] = useState(initialFormValues);
        const [errors, setErrors] = useState({});

        const handleChange = (e, fieldName) => {
            setFormValues({
                ...formValues,
                [fieldName]: e.target.value,
            });
            setErrors({
                ...errors,
                [fieldName]: '',
            });
        };

        const validateForm = (updatedValues) => {
            let isValid = true;
            const newErrors = {};

            fields.forEach((field) => {
                let value = updatedValues[field.field_name];
                const regex = field.regex;

                if (!value) {
                    isValid = false;
                    newErrors[field.field_name] = 'This field is required';
                } else if (regex && !new RegExp(regex).test(value)) {
                    isValid = false;
                    newErrors[field.field_name] = 'Invalid format';
                }
            });
            setErrors(newErrors);
            return isValid;
        };

        const handleSubmit = (e) => {
            const updatedFormValues = { ...formValues };
            fields.forEach((field) => {
                if (field.field_name.toLowerCase().includes('date')) {
                    try {
                        updatedFormValues[field.field_name] = convertDateFormat(formValues[field.field_name]);
                    } catch (error) {
                        setErrors({ [field.field_name]: 'Invalid date format' });
                        return;
                    }
                }
            });
            e.preventDefault();
            if (validateForm(updatedFormValues)) {
                setresult([]);
                let api_data = {
                    issuer_id: company.id,
                    document_id: doc.id,
                    data: updatedFormValues
                };
                getSearchResults(api_data);
                setFormData(formValues);
            }

        };

        const renderInput = (field) => {
            const { field_name, text_validator_id, number_validator_id, placeholder } = field;
            const inputProps = {
                name: field_name,
                value: formValues[field_name],
                onChange: (e) => handleChange(e, field_name),
                // required: true,
                className: styles.selectItem,
                placeholder: placeholder
            };

            return (
                <div>
                    {field_name.toLowerCase().includes("date") && <input type="date" {...inputProps} />}
                    {text_validator_id && <input type="text" {...inputProps} />}
                    {number_validator_id && <input type="number" {...inputProps} />}
                    {!field_name.toLowerCase().includes("date") && !text_validator_id && !number_validator_id && <input type="text" {...inputProps} />}
                    {errors[field_name] && <div className={styles.error} style={{ color: 'red' }}>{errors[field_name]}</div>}
                </div>
            );
        };

        return (
            <form onSubmit={handleSubmit}>
                <div className={styles.MainSearchContainer + " " + styles.formContainer} style={{ display: "flex", flexWrap: "wrap" }}>
                    {fields.map((field) => (
                        <div key={field.id} style={{ minWidth: '10rem' }}>
                            <label>{_ToNormal(field.field_name)}</label>
                            {renderInput(field)}
                        </div>
                    ))}
                </div>
                <div className={styles.MainSearchContainer}>
                    <button type="reset" className={styles.button} onClick={reset}>{BUTTONS.RESET}</button>
                    <button type="submit" className={styles.button + " " + styles.primarybutton}>{BUTTONS.SEARCH}</button>
                </div>
            </form>
        );
    };


    const SendRequest = () => {
        return (
            <div className={styles.modal_content}>
                <div className={styles.circle}>
                    <Icon icon={basic_mail} size={'3rem'} />
                </div>

                <h2>Request Sent</h2>
                <p id={styles.request_description}>{MESSAGE.REQUEST_ACCESS}</p>
                <button className={styles.close + " " + styles.button}>Start new Verification</button>
                <button className={styles.close + " " + styles.button + " " + styles.primarybutton}>{BUTTONS.CLOSE}</button>
            </div>
        )
    }

    const requestAccess = (id) => {
        setLoadshimmer(4)
        API.post(HOLDER_CONSENT, {
            "holder_id": id,
            "verifier_id": userData.id,
            "document_id": doc.id
        })
            .then(res => {
                if (res.data.status === 200) {
                    setPopup(true)
                }
            })
            .catch(err => {
                cogoToast.error(err.response.data.message)
            })
            .finally(() =>
                setLoadshimmer(0)
            )
    }

    const DisplayResult = () => {
        if (loadShimmer == 3) {
            return (
                <section className={styles.searchBox}>
                    <h2 className='topTitleBarText'>
                        <div className="shimmer" style={{ width: '5rem', height: '2rem' }} />
                    </h2>
                    <div className='shimmer' style={{ width: "100%", height: "5rem" }}>
                    </div>
                </section>)
        }
        return (
            <section className={styles.searchBox}>
                <h2 className='topTitleBarText'>
                    {result.length} result found
                </h2>
                {result.length > 0 ?
                    <table>
                        <tbody>
                            <tr className={TableStyles.chevronSortTableCell5}>
                                {DefaultFields.map((i) => (<th className={styles.th} key={i.id}>{_ToNormal(i.field_name)}</th>))}
                                <th className={TableStyles.tablescell + " " + styles.th} style={{ width: "8rem" }} >
                                    Actions
                                </th>
                            </tr>
                            <tr className={TableStyles.chevronSortTableCell}>
                                {DefaultFields.map((i) => (<td className={styles.td + " " + TableStyles.tablescell} key={i.id}>{formData[i.field_name]}</td>))}
                                <td className={styles.actions} onClick={() => requestAccess(result[0].holder_id)}>
                                    <Icon icon={androidOpen} size={'1.5rem'} />
                                    {loadShimmer == 4 ? `Requesting...` : `Request Access`}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    : null}
                <Modal title={''} isOpen={Popup} onClose={setPopup}>
                    <SendRequest />
                </Modal>
                <div className={styles.MainSearchContainer}>
                </div>
            </section>)
    }

    return (
        <SlideUpWrapper direction="slide-right">
            <div className='topTitleBar' style={{ marginBottom: "-1rem" }}>
                <div className="topTitleBarTextContainer">
                    <h2 className="topTitleBarText"> <span className="secondaryButton1">Verify Users</span></h2>
                </div>
            </div>
            <section className={styles.searchBox} >
                <h2 className='topTitleBarText'>
                    Search Employee Data:
                </h2>
                <div className={styles.MainSearchContainer}>
                    <div className={styles.selectdocument}>
                        {/* Select Issuer * */}
                        {loading ? <ShimmerLoader mt="0.6rem" height='2.4rem' /> :
                            <Dropdown
                                listType={0}
                                list={Issuers}
                                selectedOption={company}
                            />
                        }
                    </div>

                    <div className={styles.selectdocument}>
                        <Dropdown
                            listType={1}
                            list={Documents}
                            selectedOption={doc}
                        />
                    </div>

                </div>
                {
                    doc &&
                    <div className={styles.MainSearchContainer}>
                        <div className={styles.formContainer}>
                            <h2 className='topTitleBarText'>
                                Additonal Information Required
                            </h2>
                            {loadShimmer == 2 ? <div className='shimmer' style={{ width: "100%", height: "5rem" }}></div> :
                                <DynamicForm
                                    fields={DefaultFields}
                                />
                            }
                        </div>
                    </div>
                }
            </section>
            {formData && <DisplayResult />}

            <div className="credentials-table">
            </div>
        </SlideUpWrapper>
    )
}
